// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1544":"ChatContainer","6011":"OnboardTenantRouterSwitch","9615":"node_modules-react-carousel.es.css|0"}[chunkId] + "." + {"1544":"35f0a4c6","6011":"a5cc2b00","9615":"6dc7d541"}[chunkId] + ".chunk.css";
};